var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

require("core-js/modules/esnext.global-this.js");

require("core-js/modules/es.string.trim-start.js");

require("core-js/modules/es.string.trim-end.js");

/**
 * @name string-collapse-white-space
 * @fileoverview Replace chunks of whitespace with a single spaces
 * @version 9.1.0
 * @author Roy Revelt, Codsen Ltd
 * @license MIT
 * {@link https://codsen.com/os/string-collapse-white-space/}
 */
!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports) : "function" == typeof define && define.amd ? define(["exports"], e) : e((t = "undefined" != typeof globalThis ? globalThis : t || self).stringCollapseWhiteSpace = {});
}(this, function (t) {
  "use strict";
  /**
   * @name ranges-sort
   * @fileoverview Sort string index ranges
   * @version 4.1.0
   * @author Roy Revelt, Codsen Ltd
   * @license MIT
   * {@link https://codsen.com/os/ranges-sort/}
   */

  var e = {
    strictlyTwoElementsInRangeArrays: !1,
    progressFn: null
  };

  function r(t, r) {
    if (!Array.isArray(t) || !t.length) return t;

    var n = _objectSpread(_objectSpread({}, e), r);

    var i, s;
    if (n.strictlyTwoElementsInRangeArrays && !t.filter(function (t) {
      return t;
    }).every(function (t, e) {
      return 2 === t.length || (i = e, s = t.length, !1);
    })) throw new TypeError("ranges-sort: [THROW_ID_03] The first argument should be an array and must consist of arrays which are natural number indexes representing TWO string index ranges. However, ".concat(i, "th range (").concat(JSON.stringify(t[i], null, 4), ") has not two but ").concat(s, " elements!"));
    if (!t.filter(function (t) {
      return t;
    }).every(function (t, e) {
      return !(!Number.isInteger(t[0]) || t[0] < 0 || !Number.isInteger(t[1]) || t[1] < 0) || (i = e, !1);
    })) throw new TypeError("ranges-sort: [THROW_ID_04] The first argument should be an array and must consist of arrays which are natural number indexes representing string index ranges. However, ".concat(i, "th range (").concat(JSON.stringify(t[i], null, 4), ") does not consist of only natural numbers!"));
    var o = Math.pow(t.filter(function (t) {
      return t;
    }).length, 2);
    var a = 0;
    return Array.from(t).filter(function (t) {
      return t;
    }).sort(function (t, e) {
      return n.progressFn && (a += 1, n.progressFn(Math.floor(100 * a / o))), t[0] === e[0] ? t[1] < e[1] ? -1 : t[1] > e[1] ? 1 : 0 : t[0] < e[0] ? -1 : 1;
    });
  }
  /**
   * @name ranges-merge
   * @fileoverview Merge and sort string index ranges
   * @version 7.1.0
   * @author Roy Revelt, Codsen Ltd
   * @license MIT
   * {@link https://codsen.com/os/ranges-merge/}
   */


  var n = {
    mergeType: 1,
    progressFn: null,
    joinRangesThatTouchEdges: !0
  };

  function i(t, e) {
    function i(t) {
      return t && "object" == typeof t && !Array.isArray(t);
    }

    if (!Array.isArray(t) || !t.length) return null;
    var s;

    if (e) {
      if (!i(e)) throw new Error("emlint: [THROW_ID_03] the second input argument must be a plain object. It was given as:\n".concat(JSON.stringify(e, null, 4), " (type ").concat(typeof e, ")"));
      if (s = _objectSpread(_objectSpread({}, n), e), s.progressFn && i(s.progressFn) && !Object.keys(s.progressFn).length) s.progressFn = null;else if (s.progressFn && "function" != typeof s.progressFn) throw new Error("ranges-merge: [THROW_ID_01] opts.progressFn must be a function! It was given of a type: \"".concat(typeof s.progressFn, "\", equal to ").concat(JSON.stringify(s.progressFn, null, 4)));
      if (s.mergeType && 1 != +s.mergeType && 2 != +s.mergeType) throw new Error("ranges-merge: [THROW_ID_02] opts.mergeType was customised to a wrong thing! It was given of a type: \"".concat(typeof s.mergeType, "\", equal to ").concat(JSON.stringify(s.mergeType, null, 4)));
      if ("boolean" != typeof s.joinRangesThatTouchEdges) throw new Error("ranges-merge: [THROW_ID_04] opts.joinRangesThatTouchEdges was customised to a wrong thing! It was given of a type: \"".concat(typeof s.joinRangesThatTouchEdges, "\", equal to ").concat(JSON.stringify(s.joinRangesThatTouchEdges, null, 4)));
    } else s = _objectSpread({}, n);

    var o = t.filter(function (t) {
      return t;
    }).map(function (t) {
      return _toConsumableArray(t);
    }).filter(function (t) {
      return void 0 !== t[2] || t[0] !== t[1];
    });
    var a, u, l;
    if (a = s.progressFn ? r(o, {
      progressFn: function progressFn(t) {
        l = Math.floor(t / 5), l !== u && (u = l, s.progressFn(l));
      }
    }) : r(o), !a) return null;
    var c = a.length - 1;

    for (var _t2 = c; _t2 > 0; _t2--) {
      s.progressFn && (l = Math.floor(78 * (1 - _t2 / c)) + 21, l !== u && l > u && (u = l, s.progressFn(l))), (a[_t2][0] <= a[_t2 - 1][0] || !s.joinRangesThatTouchEdges && a[_t2][0] < a[_t2 - 1][1] || s.joinRangesThatTouchEdges && a[_t2][0] <= a[_t2 - 1][1]) && (a[_t2 - 1][0] = Math.min(a[_t2][0], a[_t2 - 1][0]), a[_t2 - 1][1] = Math.max(a[_t2][1], a[_t2 - 1][1]), void 0 !== a[_t2][2] && (a[_t2 - 1][0] >= a[_t2][0] || a[_t2 - 1][1] <= a[_t2][1]) && null !== a[_t2 - 1][2] && (null === a[_t2][2] && null !== a[_t2 - 1][2] ? a[_t2 - 1][2] = null : null != a[_t2 - 1][2] ? 2 == +s.mergeType && a[_t2 - 1][0] === a[_t2][0] ? a[_t2 - 1][2] = a[_t2][2] : a[_t2 - 1][2] += a[_t2][2] : a[_t2 - 1][2] = a[_t2][2]), a.splice(_t2, 1), _t2 = a.length);
    }

    return a.length ? a : null;
  }
  /**
   * @name ranges-apply
   * @fileoverview Take an array of string index ranges, delete/replace the string according to them
   * @version 5.1.0
   * @author Roy Revelt, Codsen Ltd
   * @license MIT
   * {@link https://codsen.com/os/ranges-apply/}
   */


  function s(t, e, r) {
    var n,
        s = 0,
        o = 0;
    if (0 === arguments.length) throw new Error("ranges-apply: [THROW_ID_01] inputs missing!");
    if ("string" != typeof t) throw new TypeError("ranges-apply: [THROW_ID_02] first input argument must be a string! Currently it's: ".concat(typeof t, ", equal to: ").concat(JSON.stringify(t, null, 4)));
    if (e && !Array.isArray(e)) throw new TypeError("ranges-apply: [THROW_ID_03] second input argument must be an array (or null)! Currently it's: ".concat(typeof e, ", equal to: ").concat(JSON.stringify(e, null, 4)));
    if (r && "function" != typeof r) throw new TypeError("ranges-apply: [THROW_ID_04] the third input argument must be a function (or falsey)! Currently it's: ".concat(typeof r, ", equal to: ").concat(JSON.stringify(r, null, 4)));
    if (!e || !e.filter(function (t) {
      return t;
    }).length) return t;
    n = Array.isArray(e) && Number.isInteger(e[0]) && Number.isInteger(e[1]) ? [Array.from(e)] : Array.from(e);
    var a = n.length;
    var u = 0;
    n.filter(function (t) {
      return t;
    }).forEach(function (t, e) {
      if (r && (s = Math.floor(u / a * 10), s !== o && (o = s, r(s))), !Array.isArray(t)) throw new TypeError("ranges-apply: [THROW_ID_05] ranges array, second input arg., has ".concat(e, "th element not an array: ").concat(JSON.stringify(t, null, 4), ", which is ").concat(typeof t));

      if (!Number.isInteger(t[0])) {
        if (!Number.isInteger(+t[0]) || +t[0] < 0) throw new TypeError("ranges-apply: [THROW_ID_06] ranges array, second input arg. has ".concat(e, "th element, array ").concat(JSON.stringify(t, null, 0), ". Its first element is not an integer, string index, but ").concat(typeof t[0], ", equal to: ").concat(JSON.stringify(t[0], null, 4), "."));
        n[e][0] = +n[e][0];
      }

      if (!Number.isInteger(t[1])) {
        if (!Number.isInteger(+t[1]) || +t[1] < 0) throw new TypeError("ranges-apply: [THROW_ID_07] ranges array, second input arg. has ".concat(e, "th element, array ").concat(JSON.stringify(t, null, 0), ". Its second element is not an integer, string index, but ").concat(typeof t[1], ", equal to: ").concat(JSON.stringify(t[1], null, 4), "."));
        n[e][1] = +n[e][1];
      }

      u += 1;
    });
    var l = i(n, {
      progressFn: function progressFn(t) {
        r && (s = 10 + Math.floor(t / 10), s !== o && (o = s, r(s)));
      }
    }),
        c = Array.isArray(l) ? l.length : 0;

    if (c > 0) {
      var _e = t.slice(l[c - 1][1]);

      t = l.reduce(function (e, n, i, a) {
        r && (s = 20 + Math.floor(i / c * 80), s !== o && (o = s, r(s)));
        return e + t.slice(0 === i ? 0 : a[i - 1][1], a[i][0]) + (a[i][2] || "");
      }, ""), t += _e;
    }

    return t;
  }
  /**
   * @name string-collapse-leading-whitespace
   * @fileoverview Collapse the leading and trailing whitespace of a string
   * @version 5.1.0
   * @author Roy Revelt, Codsen Ltd
   * @license MIT
   * {@link https://codsen.com/os/string-collapse-leading-whitespace/}
   */


  function o(t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    function r(t) {
      return Array.from(t).reverse().join("");
    }

    function n(t, e, r) {
      var n = r ? "\n" : "\r",
          i = r ? "\r" : "\n";
      if (!t) return t;
      var s = 0,
          o = "";

      for (var _r = 0, _a = t.length; _r < _a; _r++) {
        (t[_r] === n || t[_r] === i && t[_r - 1] !== n) && s++, "\r\n".includes(t[_r]) || " " === t[_r] ? " " === t[_r] ? o += t[_r] : t[_r] === n ? s <= e && (o += t[_r], t[_r + 1] === i && (o += t[_r + 1], _r++)) : t[_r] === i && (!t[_r - 1] || t[_r - 1] !== n) && s <= e && (o += t[_r]) : t[_r + 1] || s || (o += " ");
      }

      return o;
    }

    if ("string" == typeof t && t.length) {
      var _i = 1;
      "number" == typeof +e && Number.isInteger(+e) && +e >= 0 && (_i = +e);
      var _s = "",
          _o = "";

      if (t.trim()) {
        if (!t[0].trim()) for (var _e2 = 0, _r2 = t.length; _e2 < _r2; _e2++) {
          if (t[_e2].trim()) {
            _s = t.slice(0, _e2);
            break;
          }
        }
      } else _s = t;

      if (t.trim() && ("" === t.slice(-1).trim() || " " === t.slice(-1))) for (var _e3 = t.length; _e3--;) {
        if (t[_e3].trim()) {
          _o = t.slice(_e3 + 1);
          break;
        }
      }
      return "".concat(n(_s, _i, !1)).concat(t.trim()).concat(r(n(r(_o), _i, !0)));
    }

    return t;
  }
  /**
   * @name ranges-push
   * @fileoverview Gather string index ranges
   * @version 5.1.0
   * @author Roy Revelt, Codsen Ltd
   * @license MIT
   * {@link https://codsen.com/os/ranges-push/}
   */


  function a(t) {
    return null != t;
  }

  function u(t) {
    return Number.isInteger(t) && t >= 0;
  }

  function l(t) {
    return "string" == typeof t;
  }

  var c = {
    limitToBeAddedWhitespace: !1,
    limitLinebreaksCount: 1,
    mergeType: 1
  };

  var f = /*#__PURE__*/function () {
    function f(t) {
      _classCallCheck(this, f);

      var e = _objectSpread(_objectSpread({}, c), t);

      if (e.mergeType && 1 !== e.mergeType && 2 !== e.mergeType) if (l(e.mergeType) && "1" === e.mergeType.trim()) e.mergeType = 1;else {
        if (!l(e.mergeType) || "2" !== e.mergeType.trim()) throw new Error("ranges-push: [THROW_ID_02] opts.mergeType was customised to a wrong thing! It was given of a type: \"".concat(typeof e.mergeType, "\", equal to ").concat(JSON.stringify(e.mergeType, null, 4)));
        e.mergeType = 2;
      }
      this.opts = e, this.ranges = [];
    }

    _createClass(f, [{
      key: "add",
      value: function add(t, e, r) {
        var _this = this;

        if (null == t && null == e) return;

        if (a(t) && !a(e)) {
          if (Array.isArray(t)) {
            if (t.length) {
              if (t.some(function (t) {
                return Array.isArray(t);
              })) return void t.forEach(function (t) {
                Array.isArray(t) && _this.add.apply(_this, _toConsumableArray(t));
              });
              t.length && u(+t[0]) && u(+t[1]) && this.add.apply(this, _toConsumableArray(t));
            }

            return;
          }

          throw new TypeError("ranges-push/Ranges/add(): [THROW_ID_12] the first input argument, \"from\" is set (".concat(JSON.stringify(t, null, 0), ") but second-one, \"to\" is not (").concat(JSON.stringify(e, null, 0), ")"));
        }

        if (!a(t) && a(e)) throw new TypeError("ranges-push/Ranges/add(): [THROW_ID_13] the second input argument, \"to\" is set (".concat(JSON.stringify(e, null, 0), ") but first-one, \"from\" is not (").concat(JSON.stringify(t, null, 0), ")"));
        var n = +t,
            i = +e;
        if (u(r) && (r = String(r)), !u(n) || !u(i)) throw u(n) && n >= 0 ? new TypeError("ranges-push/Ranges/add(): [THROW_ID_10] \"to\" value, the second input argument, must be a natural number or zero! Currently it's of a type \"".concat(typeof i, "\" equal to: ").concat(JSON.stringify(i, null, 4))) : new TypeError("ranges-push/Ranges/add(): [THROW_ID_09] \"from\" value, the first input argument, must be a natural number or zero! Currently it's of a type \"".concat(typeof n, "\" equal to: ").concat(JSON.stringify(n, null, 4)));
        if (a(r) && !l(r) && !u(r)) throw new TypeError("ranges-push/Ranges/add(): [THROW_ID_08] The third argument, the value to add, was given not as string but ".concat(typeof r, ", equal to:\n").concat(JSON.stringify(r, null, 4)));

        if (a(this.ranges) && Array.isArray(this.last()) && n === this.last()[1]) {
          if (this.last()[1] = i, this.last(), null !== this.last()[2] && a(r)) {
            var _t3 = !(this.last()[2] && this.last()[2].length > 0) || this.opts && this.opts.mergeType && 1 !== this.opts.mergeType ? r : this.last()[2] + r;

            this.opts.limitToBeAddedWhitespace && (_t3 = o(_t3, this.opts.limitLinebreaksCount)), l(_t3) && !_t3.length || (this.last()[2] = _t3);
          }
        } else {
          this.ranges || (this.ranges = []);

          var _t4 = void 0 === r || l(r) && !r.length ? [n, i] : [n, i, r && this.opts.limitToBeAddedWhitespace ? o(r, this.opts.limitLinebreaksCount) : r];

          this.ranges.push(_t4);
        }
      }
    }, {
      key: "push",
      value: function push(t, e, r) {
        this.add(t, e, r);
      }
    }, {
      key: "current",
      value: function current() {
        var _this2 = this;

        return Array.isArray(this.ranges) && this.ranges.length ? (this.ranges = i(this.ranges, {
          mergeType: this.opts.mergeType
        }), this.ranges && this.opts.limitToBeAddedWhitespace ? this.ranges.map(function (t) {
          return a(t[2]) ? [t[0], t[1], o(t[2], _this2.opts.limitLinebreaksCount)] : t;
        }) : this.ranges) : null;
      }
    }, {
      key: "wipe",
      value: function wipe() {
        this.ranges = [];
      }
    }, {
      key: "replace",
      value: function replace(t) {
        if (Array.isArray(t) && t.length) {
          if (!Array.isArray(t[0]) || !u(t[0][0])) throw new Error("ranges-push/Ranges/replace(): [THROW_ID_11] Single range was given but we expected array of arrays! The first element, ".concat(JSON.stringify(t[0], null, 4), " should be an array and its first element should be an integer, a string index."));
          this.ranges = Array.from(t);
        } else this.ranges = [];
      }
    }, {
      key: "last",
      value: function last() {
        return Array.isArray(this.ranges) && this.ranges.length ? this.ranges[this.ranges.length - 1] : null;
      }
    }]);

    return f;
  }();

  var p = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
  Function.prototype.toString.call(Object);
  var g = {
    exports: {}
  };
  !function (t, e) {
    var r = "__lodash_hash_undefined__",
        n = 9007199254740991,
        i = "[object Arguments]",
        s = "[object Boolean]",
        o = "[object Date]",
        a = "[object Function]",
        u = "[object GeneratorFunction]",
        l = "[object Map]",
        c = "[object Number]",
        f = "[object Object]",
        g = "[object Promise]",
        h = "[object RegExp]",
        y = "[object Set]",
        d = "[object String]",
        m = "[object Symbol]",
        _ = "[object WeakMap]",
        b = "[object ArrayBuffer]",
        w = "[object DataView]",
        v = "[object Float32Array]",
        T = "[object Float64Array]",
        O = "[object Int8Array]",
        A = "[object Int16Array]",
        S = "[object Int32Array]",
        j = "[object Uint8Array]",
        $ = "[object Uint8ClampedArray]",
        E = "[object Uint16Array]",
        I = "[object Uint32Array]",
        R = /\w*$/,
        N = /^\[object .+?Constructor\]$/,
        W = /^(?:0|[1-9]\d*)$/,
        x = {};
    x[i] = x["[object Array]"] = x[b] = x[w] = x[s] = x[o] = x[v] = x[T] = x[O] = x[A] = x[S] = x[l] = x[c] = x[f] = x[h] = x[y] = x[d] = x[m] = x[j] = x[$] = x[E] = x[I] = !0, x["[object Error]"] = x[a] = x[_] = !1;
    var F = "object" == typeof self && self && self.Object === Object && self,
        D = "object" == typeof p && p && p.Object === Object && p || F || Function("return this")(),
        J = e && !e.nodeType && e,
        H = J && t && !t.nodeType && t,
        L = H && H.exports === J;

    function C(t, e) {
      return t.set(e[0], e[1]), t;
    }

    function q(t, e) {
      return t.add(e), t;
    }

    function M(t, e, r, n) {
      var i = -1,
          s = t ? t.length : 0;

      for (n && s && (r = t[++i]); ++i < s;) {
        r = e(r, t[i], i, t);
      }

      return r;
    }

    function k(t) {
      var e = !1;
      if (null != t && "function" != typeof t.toString) try {
        e = !!(t + "");
      } catch (t) {}
      return e;
    }

    function B(t) {
      var e = -1,
          r = Array(t.size);
      return t.forEach(function (t, n) {
        r[++e] = [n, t];
      }), r;
    }

    function P(t, e) {
      return function (r) {
        return t(e(r));
      };
    }

    function U(t) {
      var e = -1,
          r = Array(t.size);
      return t.forEach(function (t) {
        r[++e] = t;
      }), r;
    }

    var z,
        V = Array.prototype,
        G = Function.prototype,
        K = Object.prototype,
        Q = D["__core-js_shared__"],
        X = (z = /[^.]+$/.exec(Q && Q.keys && Q.keys.IE_PROTO || "")) ? "Symbol(src)_1." + z : "",
        Y = G.toString,
        Z = K.hasOwnProperty,
        tt = K.toString,
        et = RegExp("^" + Y.call(Z).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
        rt = L ? D.Buffer : void 0,
        nt = D.Symbol,
        it = D.Uint8Array,
        st = P(Object.getPrototypeOf, Object),
        ot = Object.create,
        at = K.propertyIsEnumerable,
        ut = V.splice,
        lt = Object.getOwnPropertySymbols,
        ct = rt ? rt.isBuffer : void 0,
        ft = P(Object.keys, Object),
        pt = Ht(D, "DataView"),
        gt = Ht(D, "Map"),
        ht = Ht(D, "Promise"),
        yt = Ht(D, "Set"),
        dt = Ht(D, "WeakMap"),
        mt = Ht(Object, "create"),
        _t = kt(pt),
        bt = kt(gt),
        wt = kt(ht),
        vt = kt(yt),
        Tt = kt(dt),
        Ot = nt ? nt.prototype : void 0,
        At = Ot ? Ot.valueOf : void 0;

    function St(t) {
      var e = -1,
          r = t ? t.length : 0;

      for (this.clear(); ++e < r;) {
        var n = t[e];
        this.set(n[0], n[1]);
      }
    }

    function jt(t) {
      var e = -1,
          r = t ? t.length : 0;

      for (this.clear(); ++e < r;) {
        var n = t[e];
        this.set(n[0], n[1]);
      }
    }

    function $t(t) {
      var e = -1,
          r = t ? t.length : 0;

      for (this.clear(); ++e < r;) {
        var n = t[e];
        this.set(n[0], n[1]);
      }
    }

    function Et(t) {
      this.__data__ = new jt(t);
    }

    function It(t, e) {
      var r = Pt(t) || function (t) {
        return function (t) {
          return function (t) {
            return !!t && "object" == typeof t;
          }(t) && Ut(t);
        }(t) && Z.call(t, "callee") && (!at.call(t, "callee") || tt.call(t) == i);
      }(t) ? function (t, e) {
        for (var r = -1, n = Array(t); ++r < t;) {
          n[r] = e(r);
        }

        return n;
      }(t.length, String) : [],
          n = r.length,
          s = !!n;

      for (var o in t) {
        !e && !Z.call(t, o) || s && ("length" == o || qt(o, n)) || r.push(o);
      }

      return r;
    }

    function Rt(t, e, r) {
      var n = t[e];
      Z.call(t, e) && Bt(n, r) && (void 0 !== r || e in t) || (t[e] = r);
    }

    function Nt(t, e) {
      for (var r = t.length; r--;) {
        if (Bt(t[r][0], e)) return r;
      }

      return -1;
    }

    function Wt(t, e, r, n, p, g, _) {
      var N;
      if (n && (N = g ? n(t, p, g, _) : n(t)), void 0 !== N) return N;
      if (!Gt(t)) return t;
      var W = Pt(t);

      if (W) {
        if (N = function (t) {
          var e = t.length,
              r = t.constructor(e);
          e && "string" == typeof t[0] && Z.call(t, "index") && (r.index = t.index, r.input = t.input);
          return r;
        }(t), !e) return function (t, e) {
          var r = -1,
              n = t.length;
          e || (e = Array(n));

          for (; ++r < n;) {
            e[r] = t[r];
          }

          return e;
        }(t, N);
      } else {
        var F = Ct(t),
            D = F == a || F == u;
        if (zt(t)) return function (t, e) {
          if (e) return t.slice();
          var r = new t.constructor(t.length);
          return t.copy(r), r;
        }(t, e);

        if (F == f || F == i || D && !g) {
          if (k(t)) return g ? t : {};
          if (N = function (t) {
            return "function" != typeof t.constructor || Mt(t) ? {} : (e = st(t), Gt(e) ? ot(e) : {});
            var e;
          }(D ? {} : t), !e) return function (t, e) {
            return Dt(t, Lt(t), e);
          }(t, function (t, e) {
            return t && Dt(e, Kt(e), t);
          }(N, t));
        } else {
          if (!x[F]) return g ? t : {};

          N = function (t, e, r, n) {
            var i = t.constructor;

            switch (e) {
              case b:
                return Ft(t);

              case s:
              case o:
                return new i(+t);

              case w:
                return function (t, e) {
                  var r = e ? Ft(t.buffer) : t.buffer;
                  return new t.constructor(r, t.byteOffset, t.byteLength);
                }(t, n);

              case v:
              case T:
              case O:
              case A:
              case S:
              case j:
              case $:
              case E:
              case I:
                return function (t, e) {
                  var r = e ? Ft(t.buffer) : t.buffer;
                  return new t.constructor(r, t.byteOffset, t.length);
                }(t, n);

              case l:
                return function (t, e, r) {
                  return M(e ? r(B(t), !0) : B(t), C, new t.constructor());
                }(t, n, r);

              case c:
              case d:
                return new i(t);

              case h:
                return function (t) {
                  var e = new t.constructor(t.source, R.exec(t));
                  return e.lastIndex = t.lastIndex, e;
                }(t);

              case y:
                return function (t, e, r) {
                  return M(e ? r(U(t), !0) : U(t), q, new t.constructor());
                }(t, n, r);

              case m:
                return a = t, At ? Object(At.call(a)) : {};
            }

            var a;
          }(t, F, Wt, e);
        }
      }

      _ || (_ = new Et());

      var J = _.get(t);

      if (J) return J;
      if (_.set(t, N), !W) var H = r ? function (t) {
        return function (t, e, r) {
          var n = e(t);
          return Pt(t) ? n : function (t, e) {
            for (var r = -1, n = e.length, i = t.length; ++r < n;) {
              t[i + r] = e[r];
            }

            return t;
          }(n, r(t));
        }(t, Kt, Lt);
      }(t) : Kt(t);
      return function (t, e) {
        for (var r = -1, n = t ? t.length : 0; ++r < n && !1 !== e(t[r], r, t);) {
          ;
        }
      }(H || t, function (i, s) {
        H && (i = t[s = i]), Rt(N, s, Wt(i, e, r, n, s, t, _));
      }), N;
    }

    function xt(t) {
      return !(!Gt(t) || (e = t, X && X in e)) && (Vt(t) || k(t) ? et : N).test(kt(t));
      var e;
    }

    function Ft(t) {
      var e = new t.constructor(t.byteLength);
      return new it(e).set(new it(t)), e;
    }

    function Dt(t, e, r, n) {
      r || (r = {});

      for (var i = -1, s = e.length; ++i < s;) {
        var o = e[i],
            a = n ? n(r[o], t[o], o, r, t) : void 0;
        Rt(r, o, void 0 === a ? t[o] : a);
      }

      return r;
    }

    function Jt(t, e) {
      var r,
          n,
          i = t.__data__;
      return ("string" == (n = typeof (r = e)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof e ? "string" : "hash"] : i.map;
    }

    function Ht(t, e) {
      var r = function (t, e) {
        return null == t ? void 0 : t[e];
      }(t, e);

      return xt(r) ? r : void 0;
    }

    St.prototype.clear = function () {
      this.__data__ = mt ? mt(null) : {};
    }, St.prototype.delete = function (t) {
      return this.has(t) && delete this.__data__[t];
    }, St.prototype.get = function (t) {
      var e = this.__data__;

      if (mt) {
        var n = e[t];
        return n === r ? void 0 : n;
      }

      return Z.call(e, t) ? e[t] : void 0;
    }, St.prototype.has = function (t) {
      var e = this.__data__;
      return mt ? void 0 !== e[t] : Z.call(e, t);
    }, St.prototype.set = function (t, e) {
      return this.__data__[t] = mt && void 0 === e ? r : e, this;
    }, jt.prototype.clear = function () {
      this.__data__ = [];
    }, jt.prototype.delete = function (t) {
      var e = this.__data__,
          r = Nt(e, t);
      return !(r < 0) && (r == e.length - 1 ? e.pop() : ut.call(e, r, 1), !0);
    }, jt.prototype.get = function (t) {
      var e = this.__data__,
          r = Nt(e, t);
      return r < 0 ? void 0 : e[r][1];
    }, jt.prototype.has = function (t) {
      return Nt(this.__data__, t) > -1;
    }, jt.prototype.set = function (t, e) {
      var r = this.__data__,
          n = Nt(r, t);
      return n < 0 ? r.push([t, e]) : r[n][1] = e, this;
    }, $t.prototype.clear = function () {
      this.__data__ = {
        hash: new St(),
        map: new (gt || jt)(),
        string: new St()
      };
    }, $t.prototype.delete = function (t) {
      return Jt(this, t).delete(t);
    }, $t.prototype.get = function (t) {
      return Jt(this, t).get(t);
    }, $t.prototype.has = function (t) {
      return Jt(this, t).has(t);
    }, $t.prototype.set = function (t, e) {
      return Jt(this, t).set(t, e), this;
    }, Et.prototype.clear = function () {
      this.__data__ = new jt();
    }, Et.prototype.delete = function (t) {
      return this.__data__.delete(t);
    }, Et.prototype.get = function (t) {
      return this.__data__.get(t);
    }, Et.prototype.has = function (t) {
      return this.__data__.has(t);
    }, Et.prototype.set = function (t, e) {
      var r = this.__data__;

      if (r instanceof jt) {
        var n = r.__data__;
        if (!gt || n.length < 199) return n.push([t, e]), this;
        r = this.__data__ = new $t(n);
      }

      return r.set(t, e), this;
    };

    var Lt = lt ? P(lt, Object) : function () {
      return [];
    },
        Ct = function Ct(t) {
      return tt.call(t);
    };

    function qt(t, e) {
      return !!(e = null == e ? n : e) && ("number" == typeof t || W.test(t)) && t > -1 && t % 1 == 0 && t < e;
    }

    function Mt(t) {
      var e = t && t.constructor;
      return t === ("function" == typeof e && e.prototype || K);
    }

    function kt(t) {
      if (null != t) {
        try {
          return Y.call(t);
        } catch (t) {}

        try {
          return t + "";
        } catch (t) {}
      }

      return "";
    }

    function Bt(t, e) {
      return t === e || t != t && e != e;
    }

    (pt && Ct(new pt(new ArrayBuffer(1))) != w || gt && Ct(new gt()) != l || ht && Ct(ht.resolve()) != g || yt && Ct(new yt()) != y || dt && Ct(new dt()) != _) && (Ct = function Ct(t) {
      var e = tt.call(t),
          r = e == f ? t.constructor : void 0,
          n = r ? kt(r) : void 0;
      if (n) switch (n) {
        case _t:
          return w;

        case bt:
          return l;

        case wt:
          return g;

        case vt:
          return y;

        case Tt:
          return _;
      }
      return e;
    });
    var Pt = Array.isArray;

    function Ut(t) {
      return null != t && function (t) {
        return "number" == typeof t && t > -1 && t % 1 == 0 && t <= n;
      }(t.length) && !Vt(t);
    }

    var zt = ct || function () {
      return !1;
    };

    function Vt(t) {
      var e = Gt(t) ? tt.call(t) : "";
      return e == a || e == u;
    }

    function Gt(t) {
      var e = typeof t;
      return !!t && ("object" == e || "function" == e);
    }

    function Kt(t) {
      return Ut(t) ? It(t) : function (t) {
        if (!Mt(t)) return ft(t);
        var e = [];

        for (var r in Object(t)) {
          Z.call(t, r) && "constructor" != r && e.push(r);
        }

        return e;
      }(t);
    }

    t.exports = function (t) {
      return Wt(t, !0, !0);
    };
  }(g, g.exports);

  function h(t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return function (_ref) {
      var t = _ref.str,
          _ref$idx = _ref.idx,
          e = _ref$idx === void 0 ? 0 : _ref$idx,
          _ref$stopAtNewlines = _ref.stopAtNewlines,
          r = _ref$stopAtNewlines === void 0 ? !1 : _ref$stopAtNewlines,
          _ref$stopAtRawNbsp = _ref.stopAtRawNbsp,
          n = _ref$stopAtRawNbsp === void 0 ? !1 : _ref$stopAtRawNbsp;
      if ("string" != typeof t || !t.length) return null;
      if (e && "number" == typeof e || (e = 0), !t[e + 1]) return null;
      if (t[e + 1] && (t[e + 1].trim() || r && "\n\r".includes(t[e + 1]) || n && " " === t[e + 1])) return e + 1;
      if (t[e + 2] && (t[e + 2].trim() || r && "\n\r".includes(t[e + 2]) || n && " " === t[e + 2])) return e + 2;

      for (var _i2 = e + 1, _s2 = t.length; _i2 < _s2; _i2++) {
        if (t[_i2].trim() || r && "\n\r".includes(t[_i2]) || n && " " === t[_i2]) return _i2;
      }

      return null;
    }({
      str: t,
      idx: e,
      stopAtNewlines: !1,
      stopAtRawNbsp: !1
    });
  }

  var y = {
    trimStart: !0,
    trimEnd: !0,
    trimLines: !1,
    trimnbsp: !1,
    removeEmptyLines: !1,
    limitConsecutiveEmptyLinesTo: 0,
    enforceSpacesOnly: !1,
    cb: function cb(_ref2) {
      var t = _ref2.suggested;
      return t;
    }
  };
  t.cbSchema = ["suggested", "whiteSpaceStartsAt", "whiteSpaceEndsAt", "str"], t.collapse = function (t, e) {
    if ("string" != typeof t) throw new Error("string-collapse-white-space/collapse(): [THROW_ID_01] The input is not string but ".concat(typeof t, ", equal to: ").concat(JSON.stringify(t, null, 4)));
    if (e && "object" != typeof e) throw new Error("string-collapse-white-space/collapse(): [THROW_ID_02] The opts is not a plain object but ".concat(typeof e, ", equal to:\n").concat(JSON.stringify(e, null, 4)));
    if (!t.length) return {
      result: "",
      ranges: null
    };

    var r = new f(),
        n = " ",
        i = _objectSpread(_objectSpread({}, y), e);

    function o(t, e) {
      if ("function" == typeof i.cb) {
        var _n = i.cb(_objectSpread({
          suggested: t
        }, e));

        Array.isArray(_n) && r.push.apply(r, _toConsumableArray(_n));
      } else t && r.push.apply(r, _toConsumableArray(t));
    }

    var a = null,
        u = null,
        l = null,
        c = null,
        p = null,
        g = !1;
    var d = [];
    var m = 0;

    for (var _e4 = 0, _r3 = t.length; _e4 <= _r3; _e4++) {
      if (("\r" === t[_e4] || "\n" === t[_e4] && "\r" !== t[_e4 - 1]) && (m += 1, null === c && (c = _e4), p = "\r" === t[_e4] && "\n" === t[_e4 + 1] ? _e4 + 2 : _e4 + 1), i.trimnbsp || t[_e4] !== n || g || (g = !0), null !== a && " " !== t[_e4]) {
        var _r4 = a && u || !u && (!i.trimStart || !i.trimnbsp && (t[_e4] === n || t[a - 1] === n)),
            _s3 = t[_e4] || !i.trimEnd || !i.trimnbsp && (t[_e4] === n || t[a - 1] === n),
            _o2 = !i.enforceSpacesOnly || (!t[a - 1] || t[a - 1].trim()) && (!t[_e4] || t[_e4].trim());

        if (a < _e4 - 1 && _r4 && _s3 && _o2) {
          var _r5 = a;
          var _n2 = _e4,
              _s4 = " ";
          i.trimLines && (!a || !t[_e4] || t[a - 1] && "\r\n".includes(t[a - 1]) || t[_e4] && "\r\n".includes(t[_e4])) && (_s4 = null), _s4 && " " === t[a] && (_n2 -= 1, _s4 = null), (!a && i.trimStart || !t[_e4] && i.trimEnd) && (_n2 = _e4), d.push([_s4 ? [_r5, _n2, _s4] : [_r5, _n2], {
            whiteSpaceStartsAt: u,
            whiteSpaceEndsAt: h(t, _e4 - 1) || _e4,
            str: t
          }]);
        }
      }

      if (null === a && " " === t[_e4] && (a = _e4), null === u && t[_e4] && !t[_e4].trim() && (u = _e4), null !== l && ("\n\r".includes(t[_e4]) || !t[_e4] || t[_e4].trim() || !i.trimnbsp && !i.enforceSpacesOnly && t[_e4] === n) && (l || !i.trimStart || i.enforceSpacesOnly && g) && (t[_e4] || !i.trimEnd || i.enforceSpacesOnly && g)) {
        if (i.enforceSpacesOnly && (_e4 > l + 1 || " " !== t[l])) {
          var _r6 = l,
              _n3 = _e4,
              _s5 = " ";
          " " === t[_n3 - 1] ? (_n3 -= 1, _s5 = null) : " " === t[l] && (_r6 += 1, _s5 = null), ((i.trimStart || i.trimLines) && !l || (i.trimEnd || i.trimLines) && !t[_e4]) && (_s5 = null), o(_s5 ? [_r6, _n3, _s5] : [_r6, _n3], {
            whiteSpaceStartsAt: u,
            whiteSpaceEndsAt: _e4,
            str: t
          });
        }

        !i.trimLines || l && !"\r\n".includes(t[l - 1]) && t[_e4] && !"\r\n".includes(t[_e4]) || !i.trimnbsp && g || o([l, _e4], {
          whiteSpaceStartsAt: u,
          whiteSpaceEndsAt: h(t, _e4 - 1) || _e4,
          str: t
        }), l = null;
      }

      if (null !== l || "\r\n".includes(t[_e4]) || !t[_e4] || t[_e4].trim() || !i.trimnbsp && t[_e4] === n && !i.enforceSpacesOnly || (l = _e4), null !== u && (!t[_e4] || t[_e4].trim())) {
        if ((!u && (i.trimStart || i.trimLines && null === c) || !t[_e4] && (i.trimEnd || i.trimLines && null === c)) && (i.trimnbsp || !g || i.enforceSpacesOnly)) o([u, _e4], {
          whiteSpaceStartsAt: u,
          whiteSpaceEndsAt: _e4,
          str: t
        });else {
          var _r7 = !1;

          if (i.removeEmptyLines && null !== c && m > (i.limitConsecutiveEmptyLinesTo || 0) + 1) {
            _r7 = !0;

            var _n4 = c,
                _s6 = p || t.length,
                _a2 = "".concat("\r" === t[c] && "\n" === t[c + 1] ? "\r\n" : t[c]).repeat((i.limitConsecutiveEmptyLinesTo || 0) + 1);

            t.endsWith(_a2, p) ? (_s6 -= _a2.length || 0, _a2 = null) : t.startsWith(_a2, c) && (_n4 += _a2.length, _a2 = null), o(_a2 ? [_n4, _s6, _a2] : [_n4, _s6], {
              whiteSpaceStartsAt: u,
              whiteSpaceEndsAt: _e4,
              str: t
            });
          }

          if (d.length) {
            for (; d.length;) {
              o.apply(void 0, _toConsumableArray(d.shift()));
            }

            _r7 = !0;
          }

          _r7 || o(null, {
            whiteSpaceStartsAt: u,
            whiteSpaceEndsAt: _e4,
            str: t
          });
        }
        u = null, l = null, g = !1, m && (m = 0, c = null, p = null);
      }

      null !== a && " " !== t[_e4] && (a = null);
    }

    return {
      result: s(t, r.current()),
      ranges: r.current()
    };
  }, t.defaults = y, t.version = "9.1.0", Object.defineProperty(t, "__esModule", {
    value: !0
  });
});